import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "@/core/store";
import { ICDUserDto, ICDOrganisationDto } from "@/core/models/CDIdentityModels";
import { discoveryService } from "@/core/services/DiscoveryService";

export interface ICDIdentityState {
  cdOrganisation: ICDOrganisationDto;
  cdUser: ICDUserDto;
}

export const storageKey = "vuex";
const initialStoreContent = localStorage.getItem(storageKey);
export const initialUnencryptedStorage = initialStoreContent ? JSON.parse(initialStoreContent) : {};

@Module({
  dynamic: true,
  store,
  name: "cdIdentity",
  preserveState: Boolean(initialUnencryptedStorage["cdIdentity"])
})
class CDIdentity extends VuexModule implements ICDIdentityState {
  public cdOrganisation = {} as ICDOrganisationDto;
  public cdUser = {} as ICDUserDto;

  @Action
  public async LoadUser(input: { idp: string; cdUserId: string }) {
    if (input.idp === "local") {
      this.SET_CD_USER({
        id: "",
        accountReference: "",
        accountType: 0,
        organisations: [],
        roles: [],
        photoBase64: "",
        isActive: false
      });
    } else if (input.idp === "AzureADB2C") {
      const data = await discoveryService.getUser(input.cdUserId);
      this.SET_CD_USER(data);
    }
  }

  @Action
  public async LoadOrganisation(input: { idp: string; cdOrganisationId: string }) {
    if (input.idp === "local") {
      this.SET_CD_ORGANISATION({
        id: "",
        name: "",
        description: "",
        isActive: false,
        tenants: [],
        logoUrl: null
      });
    } else if (input.idp === "AzureADB2C") {
      const data = await discoveryService.getOrganisation(input.cdOrganisationId);
      this.SET_CD_ORGANISATION(data);
    }
  }

  @Mutation
  public SET_CD_ORGANISATION(org: ICDOrganisationDto) {
    this.cdOrganisation = org;
  }

  @Mutation
  public SET_CD_USER(cdUser: ICDUserDto) {
    this.cdUser = cdUser;
  }
}

export const CDIdentityModule = getModule(CDIdentity);
